type PostHogIdentifiableUser = {
    email: string
    firstName: string
    lastName: string
}

type PostHogIdentifiableOrg = {
    id: string
    name: string
}

type PostHogIdentifyAction =
    | {
          type: "identify"
          distinctId: string
          properties: PostHogIdentifiableUser
      }
    | {
          type: "group"
          groupType: "org"
          groupKey: string
          properties: { name: string }
      }

export function resolvePostHogIdentifyAction(params: {
    user: PostHogIdentifiableUser | undefined
    isLoading: boolean
    org?: PostHogIdentifiableOrg
}): PostHogIdentifyAction[] {
    const { user, isLoading, org } = params

    if (isLoading) {
        return []
    }

    if (user) {
        const actions: PostHogIdentifyAction[] = [
            {
                type: "identify",
                distinctId: user.email,
                properties: {
                    email: user.email,
                    firstName: user.firstName,
                    lastName: user.lastName,
                },
            },
        ]

        if (org) {
            actions.push({
                type: "group",
                groupType: "org",
                groupKey: org.id,
                properties: { name: org.name },
            })
        }

        return actions
    }

    return []
}
